import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lms-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss']
})
export class GamesComponent implements OnInit {
  public listId = 'GAMES_LIST';
  constructor() {}

  ngOnInit(): void {}
}
